export class Timeseries {
    date: Date[];
    series: Map<string, number[]>;
}
